module.exports = __webpack_public_path__ + "static/Intersectional_Futures_Network-49135478179552693864c76df974bc2b.png";